export default (function (obj, NAMESPACE) {
  return Object.assign({}, obj, {
    NAMESPACE: NAMESPACE,
    ns: function ns() {
      return this[this.NAMESPACE] || {};
    }
  });
});